import {Component, Inject, OnInit, Input, ElementRef, PLATFORM_ID, CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import {isPlatformBrowser} from '@angular/common';
import { CommonModule } from '@angular/common';
import { JsonLdService } from '../../services/json-ld.service';
import {WordpressService} from "../../services/wordpress.service";
import {first} from "rxjs";
import {BlogList} from "../../models/blogList.model";
import {DomSanitizer, SafeHtml} from "@angular/platform-browser";

@Component({
  selector: 'app-review-slider',
  templateUrl: './review-slider.component.html',
  styleUrls: ['./review-slider.component.less'],
  standalone: true,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    CommonModule
  ]
})
export class ReviewSliderComponent implements OnInit {
  @Input() currentArticle: number | undefined;
  posts: BlogList[] = [];

  constructor(
    private el: ElementRef,
    private WordPressService: WordpressService,
    private sanitizer: DomSanitizer,
    private jsonLdService: JsonLdService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
  }

  ngOnInit(): void {
    this.WordPressService.getRandomRatings(20).pipe(first()).subscribe(posts => {
      this.posts = posts;
      this.injectJsonLd(posts);
      setTimeout(() => this.initSwiper(), 0);
    })
  }

  private initSwiper(): void {
    if (!isPlatformBrowser(this.platformId)) return;
    const swiperEl = this.el.nativeElement.querySelector('swiper-container');
    if (!swiperEl) return;
    Object.assign(swiperEl, {
      slidesPerView: 1,
      spaceBetween: 20,
      pagination: { clickable: true },
      autoHeight: true,
      breakpoints: { 1100: { slidesPerView: 2, spaceBetween: 20 } },
    });
    swiperEl.initialize();
  }

  decodeEntities(encoded: string) {
    if (isPlatformBrowser(this.platformId)) {
      const txt = document.createElement('textarea');
      txt.innerHTML = encoded;
      return this.sanitizer.bypassSecurityTrustHtml(txt.value);
    }
    // Server-side fallback: decode common HTML entities without DOM
    const decoded = encoded
      .replace(/&amp;/g, '&')
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>')
      .replace(/&quot;/g, '"')
      .replace(/&#039;/g, "'")
      .replace(/&apos;/g, "'")
      .replace(/&nbsp;/g, '\u00A0');
    return this.sanitizer.bypassSecurityTrustHtml(decoded);
  }

  private injectJsonLd(posts: any[]): void {
    const ratings = posts.map(p => Number(p.acf?.rating || 5));
    const avgRating = (ratings.reduce((a, b) => a + b, 0) / ratings.length).toFixed(1);

    const json = {
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      "name": "Dart Rock Café",
      "url": "https://dart-rock-cafe.de",
      "image": "https://dart-rock-cafe.de/assets/images/DRC-Logo.svg",
      "telephone": "+49 561 515643",
      "priceRange": "€€",
      "openingHours": ["Mi-Do 17:00-23:00", "Fr-Sa 17:00-01:00"],
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "Hauptstraße 46",
        "addressLocality": "Lohfelden",
        "postalCode": "34253",
        "addressCountry": "DE"
      },
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": avgRating,
        "reviewCount": ratings.length
      },
      "review": posts.map(post => ({
        "@type": "Review",
        "author": { "@type": "Person", "name": post.title.rendered || "Community Mitglied" },
        "reviewBody": post.content.rendered.replace(/<[^>]+>/g, ''),
        "reviewRating": {
          "@type": "Rating",
          "ratingValue": post.acf?.rating || "5",
          "bestRating": "5",
          "worstRating": "1"
        }
      }))
    };

    this.jsonLdService.addData(json);
  }
}
